import React, { memo } from "react";

function NotFound() {
// Author:      Darshan Patil
// Create date: 09/01/2025
// Description: Not Found Page if no route match this page content will be displayed.
    return (
   <>
  <div>
    <h1>404 - Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
  </div>
   </>
    );
  }
  
  export default NotFound;
  

